import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

const InstagramSection = () => {
  // These would typically come from Instagram API, but for now we'll use placeholder structure
  const instagramHandle = '@dublinholisticmassage';
  const instagramUrl = 'https://www.instagram.com/dublinholisticmassage/';
  
  // Sample posts - in production, these would be fetched from Instagram API
  const posts = [
    {
      id: 1,
      image: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/8hyccr74_IMG-20260128-WA0021.jpg",
      likes: 124,
      caption: "Couples massage room ready for Valentine's Day 💕"
    },
    {
      id: 2,
      image: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/r8vdjxvy_IMG-20260128-WA0020.jpg",
      likes: 98,
      caption: "Romantic ambiance awaits ✨"
    },
    {
      id: 3,
      image: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/dir4mry1_Screenshot_20260127_173012_Instagram.jpg",
      likes: 156,
      caption: "Your relaxation journey starts here 🌿"
    },
    {
      id: 4,
      image: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/k6wkkyti_Screenshot_20260127_173054_Instagram.jpg",
      likes: 89,
      caption: "Professional care in a serene setting 💆‍♀️"
    },
    {
      id: 5,
      image: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/3oarhh6e_Screenshot_20260128_212225_Gallery.jpg",
      likes: 201,
      caption: "Our amazing therapist Glaucia at work ⭐"
    },
    {
      id: 6,
      image: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/a2rw88g0_Screenshot_20260113_221311_Instagram.jpg",
      likes: 178,
      caption: "Meet Ana - 10+ years of experience 💫"
    }
  ];

  return (
    <section id="instagram" className="py-28 bg-bone relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-luxury-gold text-xs uppercase tracking-[0.3em] font-medium">Follow Us</span>
          
          <h2 className="font-display text-3xl sm:text-4xl text-luxury-green mt-4 mb-4">
            Behind the
            <span className="italic text-luxury-green/70"> Scenes</span>
          </h2>
          
          <p className="text-stone-500 font-light max-w-2xl mx-auto">
            Follow us for wellness tips, behind-the-scenes moments, and exclusive offers!
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {posts.map((post) => (
            <a
              key={post.id}
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="relative aspect-square group overflow-hidden rounded-xl"
            >
              <img 
                src={post.image}
                alt={post.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-white text-center p-3">
                  <Instagram size={24} className="mx-auto mb-2" />
                  <p className="text-xs line-clamp-2">{post.caption}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Follow Button */}
        <div className="text-center mt-10">
          <Button
            onClick={() => window.open(instagramUrl, '_blank')}
            className="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 hover:from-purple-600 hover:via-pink-600 hover:to-orange-600 text-white px-8 py-4 rounded-full text-lg shadow-lg hover:shadow-xl transition-all"
            data-testid="follow-instagram-btn"
          >
            <Instagram size={20} className="mr-2" />
            Follow on Instagram
            <ExternalLink size={16} className="ml-2" />
          </Button>
        </div>

        {/* Stats */}
        <div className="mt-12 flex justify-center gap-12">
          <div className="text-center">
            <p className="text-3xl font-bold text-stone-800">2.5K+</p>
            <p className="text-stone-500 text-sm">Followers</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-stone-800">500+</p>
            <p className="text-stone-500 text-sm">Posts</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-stone-800">⭐ 4.9</p>
            <p className="text-stone-500 text-sm">Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
